module.exports = __webpack_public_path__ + "static/media/carrorama-starter.cbd35e88.jp2";